import React from 'react';
import HeaderNav from '@xo-union/tk-component-header-nav-redux/remote';
import { Provider } from 'react-redux';
import '@xo-union/tk-ui-essentials';
import SubNav from './sub-nav';
import store from '../../utilities/store';
import '../../initializers/loadMember';

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: props.isMobile
    }
  }

  onWindowResize = () => {
    const isMobile = $(window).width() < 768;

    this.setState({isMobile: isMobile})
  };

  componentDidMount() {
    this.onWindowResize();

    if(window && window.addEventListener) {
      window.addEventListener('resize', this.onWindowResize)
    }
  }

  render(){
    const { subNavItems, activeItem } = this.props;
    const { isMobile } = this.state;
    const analyticsProps = { product: "fashion" };

    return (
      <Provider store={store}>
        <div id='fashion-header-nav'>
          <HeaderNav activeProduct="attire-rings" metadata={{applicationName: 'fashion'}} analyticsProps={analyticsProps} ssi/>
          {
            !isMobile && <SubNav subNavItems={subNavItems} activeItem={activeItem} />
          }
        </div>
      </Provider>
    );
  }
}
